import {Sharing, SharingStatus, TenantType} from "@/core/interfaces/Sharing";
import {HospitalUserRole} from "@/core/interfaces/hospital/Hospital";

/**
 * The sharing service.
 */
const SharingService = () => {
    /**
     * Get the applicant role for a given sharing.
     * The applicant role should match the tenant of the sharing.
     *
     * @param {Sharing} sharing
     * @return {HospitalUserRole | null}
     */
    const applicantRole = (sharing: Sharing): HospitalUserRole | null => {
        if (!sharing.applicant.hospital_roles) {
            return null;
        }

        switch (sharing.tenant_type) {
        case TenantType.HOSPITAL_UNIT:
            return sharing.applicant.hospital_roles.find((role) => {
                return role.unit.id === sharing.tenant.id;
            }) || null;
        default:
            return sharing.applicant.hospital_roles[0];
        }
    };

    const sortSharings = (a: Sharing, b: Sharing): number => {
        const statusOrder = {
            [SharingStatus.PENDING]: 1,
            [SharingStatus.AUTHORIZED]: 2,
            [SharingStatus.DECLINED]: 3
        };

        return statusOrder[a.status] - statusOrder[b.status];
    };

    return {
        applicantRole,
        sortSharings
    };
};

export default SharingService();
